import React from 'react';
import {bool, func, string, node, shape} from 'prop-types';
import classNames from 'classnames';

import {Pure} from '@sinclair-digital/sbg-util/dist/es/react';
import classes from './UploadButton.scss';
import Button from '../Button';

/*
 * UploadButton React Component
 * Note on usage: using children (pass in your own custom button as the input method) will require that the click
 *  event is allowed to bubble up to the label element.  This can be achieved via css, 'pointer-events: none;'.
 */
export const UploadButton = Pure({
  propTypes: {
    className: string,
    onFilesSelected: func.isRequired,
    disabled: bool,
    children: node,
    buttonProps: shape({
      displayType: string,
      className: string,
      children: node,
    }),
  },
})(({className, onFilesSelected, disabled, children, buttonProps, ...inputProps}) => {
  let ref;
  return (
    <label className={classNames(className, classes.UploadButton)}>
      <input
        className={classes.uploadFile}
        type="file"
        capture={true}
        disabled={disabled}
        onChange={({target}) => onFilesSelected(target.files)}
        ref={(input) => ref = input}
        {...inputProps}
      />
      {buttonProps && <Button {...buttonProps} disabled={disabled} onClick={() => ref.click()} />}
      {children}
    </label>
  );
});

export default UploadButton;
